import { useState, useEffect } from 'react';
import { tx } from './i18n';

// ── Wspoldzielone hooki ──────────────────────────────────────────────────────
// Wydzielone z App.js (refactor) -- uzywane przez wiele modulow, wiec osobny
// plik zamiast eksportu z App.js (co tworzyloby cykliczne importy).

// Grupy motywow -- uzywane do grupowania w selektorze (optgroup) i w
// siatce w Ustawieniach konta -> Wyglad, zeby 11 motywow nie bylo jedna
// nieczytelna lista. Kolejnosc = kolejnosc sekcji w UI.
export const THEME_GROUPS = [
  // Glowne -- dopracowane w kazdym widoku; reszta to dodatki (patrz
  // Ustawienia konta -> Wyglad: "Wiecej motywow").
  { id: 'main', label: tx('Główne') },
  { id: 'standard', label: tx('Dodatkowe: stonowane') },
  { id: 'retro', label: tx('Dodatkowe: retro') },
  { id: 'climate', label: tx('Dodatkowe: klimatyczne') },
  { id: 'fx', label: tx('Dodatkowe: efektowne') },
  // Motywy w barwach zaprzyjaznionych serwisow krotkofalarskich -- dla wszystkich.
  { id: 'special', label: tx('Specjalne') },
  // W barwach kraju -- kazdy widoczny tylko dla znakow z tego kraju (admin: wszystkie).
  { id: 'national', label: tx('Narodowe (wg Twojego znaku)') },
  // Widoczna TYLKO gdy jest w niej co pokazac (patrz visibleThemeGroups
  // nizej) -- motyw "youtube" jest `restricted`, wiec zwykli userzy nigdy
  // nie zobacza tej sekcji w ogole, nie tylko pojedynczego motywu w niej.
  { id: 'exclusive', label: tx('Ekskluzywne (Youtuber)') },
];

// Lista dostepnych motywow -- pojedyncze zrodlo prawdy dla wszystkich
// przelacznikow w apce (patrz uwaga przy useTheme nizej). Kolejnosc = kolejnosc
// w selektorze. Kazdy odpowiada blokowi [data-theme="..."] w App.css.
// Kazdy ma tez `group` (patrz THEME_GROUPS powyzej) -- tyle motywow naraz
// (19) bez podzialu na sekcje byloby nieczytelna sciana przyciskow, a przy
// tylu opcjach kazdy powinien latwo znalezc cos dla siebie.
export const THEMES = [
  { id: 'dark', label: tx('Ciemny'), icon: '🌙', group: 'main' },
  { id: 'light', label: tx('Jasny'), icon: '☀️', group: 'main' },
  { id: 'calm', label: tx('Spokojny'), icon: '🌿', group: 'standard' },
  { id: 'contrast', label: tx('Wysoki kontrast'), icon: '⬛', group: 'main' },
  { id: 'blueprint', label: tx('Kalka'), icon: '📐', group: 'standard' },
  { id: 'mono', label: tx('Mono'), icon: '⬜', group: 'standard' },
  { id: 'xp', label: 'XP', icon: '🖥️', group: 'retro' },
  { id: 'vista', label: tx('Vista'), icon: '🪟', group: 'retro' },
  { id: 'sepia', label: tx('Sepia'), icon: '📜', group: 'retro' },
  // Cztery ponizej -- w odroznieniu od powyzszych maja TEZ wlasny zestaw
  // ikon nawigacji (patrz THEME_NAV_ICONS nizej), widoczny w bocznym menu
  // (Ustawienia konta -> Wyglad -> Ulozenie menu -> Sidebar).
  { id: 'terminal', label: tx('Terminal'), icon: '🖳', group: 'retro' },
  { id: 'ocean', label: tx('Ocean'), icon: '🌊', group: 'climate' },
  { id: 'forest', label: tx('Las'), icon: '🌲', group: 'climate' },
  { id: 'desert', label: tx('Pustynia'), icon: '🏜️', group: 'climate' },
  { id: 'winter', label: tx('Zima'), icon: '❄️', group: 'climate' },
  { id: 'spring', label: tx('Wiosna'), icon: '🌸', group: 'climate' },
  { id: 'neon', label: tx('Neon'), icon: '⚡', group: 'fx' },
  { id: 'dusk', label: tx('Zmierzch'), icon: '🌆', group: 'fx' },
  { id: 'space', label: tx('Kosmos'), icon: '🌌', group: 'fx' },
  { id: 'midnight', label: tx('Północ'), icon: '🌑', group: 'fx' },
  // W barwach sqlink.pl (siec polaczen glosowych) -- grafit, zielony neon,
  // pomaranczowe logo w pikselowym foncie. Patrz [data-theme="sqlink"] w App.css.
  { id: 'sqlink', label: 'SQLink', icon: '📡', group: 'special' },
  // Animowane (eksperymentalne) -- na wzor gradientowych motywow Discorda. Ruch tylko
  // jednej warstwy tla przez transform (tanie), patrz "MOTYWY ANIMOWANE" w App.css.
  { id: 'anim-aurora', label: tx('Zorza'), icon: '🌌', group: 'special', experimental: true },
  { id: 'anim-sunset', label: tx('Zachód słońca'), icon: '🌇', group: 'special', experimental: true },
  { id: 'anim-chroma', label: tx('Chroma'), icon: '🌈', group: 'special', experimental: true },
  // Motywy narodowe -- `countries` = nazwy encji DXCC z cty.dat (jak home_country z
  // /api/auth/me). Widoczne tylko dla znakow z tych krajow; admin widzi wszystkie.
  { id: 'nat-pl', label: tx('Polska'), icon: '🇵🇱', group: 'national', countries: ["Poland"] },
  { id: 'nat-de', label: tx('Niemcy'), icon: '🇩🇪', group: 'national', countries: ["Fed. Rep. of Germany"] },
  { id: 'nat-fr', label: tx('Francja'), icon: '🇫🇷', group: 'national', countries: ["France"] },
  { id: 'nat-it', label: tx('Włochy'), icon: '🇮🇹', group: 'national', countries: ["Italy"] },
  { id: 'nat-es', label: tx('Hiszpania'), icon: '🇪🇸', group: 'national', countries: ["Spain"] },
  { id: 'nat-nl', label: tx('Holandia'), icon: '🇳🇱', group: 'national', countries: ["Netherlands"] },
  { id: 'nat-cz', label: tx('Czechy'), icon: '🇨🇿', group: 'national', countries: ["Czech Republic"] },
  { id: 'nat-at', label: tx('Austria'), icon: '🇦🇹', group: 'national', countries: ["Austria"] },
  { id: 'nat-se', label: tx('Szwecja'), icon: '🇸🇪', group: 'national', countries: ["Sweden"] },
  { id: 'nat-be', label: tx('Belgia'), icon: '🇧🇪', group: 'national', countries: ["Belgium"] },
  { id: 'nat-ua', label: tx('Ukraina'), icon: '🇺🇦', group: 'national', countries: ["Ukraine"] },
  { id: 'nat-ru', label: tx('Rosja'), icon: '🇷🇺', group: 'national', countries: ["European Russia", "Asiatic Russia", "Kaliningrad"] },
  // Motyw w barwach YouTube -- WYLACZNIE dla grupy Youtuber (User.is_youtuber)
  // albo admina (do testow), patrz `restricted` + visibleThemes nizej.
  // Okna i powiadomienia jak w innych motywach -- patrz [data-theme="youtube"] w App.css.
  { id: 'youtube', label: tx('YouTube'), icon: '▶️', group: 'exclusive', restricted: true },
  // Easter egg dla konkretnego Youtubera (SQ7SE / "Sierra Echo") -- oparty na
  // screenshocie wodospadu SDR, ktory przyslal (niebieskie tlo szumu,
  // czerwono-zolte pasma sygnalow, biale linie siatki czestotliwosci).
  // `restrictedTo` = TYLKO ten jeden znak (case-insensitive), NIE cala grupa
  // Youtuberow -- patrz visibleThemes nizej.
  { id: 'waterfall', label: tx('Wodospad SE'), icon: '📡', group: 'exclusive', restricted: true, restrictedTo: 'SQ7SE' },
];

// Zwraca liste motywow widocznych dla danego usera:
// - motywy bez `restricted` -- widoczne zawsze
// - `restricted` bez `restrictedTo` (np. "youtube") -- widoczne dla
//   Youtuberow (User.is_youtuber) i adminow (do testow)
// - `restricted` z `restrictedTo` (personalny easter egg, np. "waterfall")
//   -- widoczny WYLACZNIE dla usera o tym dokladnym znaku (plus admin, do
//   testow), niezaleznie od tego czy ma flage is_youtuber
// - odblokowane przez admina dla tej stacji (userProfile.unlocked_themes) -- zawsze
// - `countries` (motywy narodowe) -- widoczne tylko, gdy kraj znaku domowego
//   (userProfile.home_country, z cty.dat) jest na liscie; admin widzi wszystkie
// Brak userProfile (np. ekran logowania, strona regulaminu -- przed
// zalogowaniem) = bezpieczny domyslny brak dostepu do czegokolwiek `restricted`.
export function visibleThemes(userProfile) {
  const isAdmin = !!userProfile?.is_admin;
  const isYoutuber = !!userProfile?.is_youtuber;
  const callsign = (userProfile?.callsign || '').toUpperCase();
  const country = userProfile?.home_country || '';
  const unlocked = Array.isArray(userProfile?.unlocked_themes) ? userProfile.unlocked_themes : [];
  return THEMES.filter(th => {
    // Odblokowane przez admina dla tej stacji -- zawsze widoczne
    if (unlocked.includes(th.id)) return true;
    // Narodowe: tylko dla znakow z danego kraju (i admina)
    if (th.countries) return isAdmin || th.countries.includes(country);
    if (!th.restricted) return true;
    if (isAdmin) return true;
    if (th.restrictedTo) return callsign === th.restrictedTo.toUpperCase();
    return isYoutuber;
  });
}

// Domyslne ikony pozycji menu -- uzywane w bocznym pasku nawigacji (Sidebar).
// Osobne od etykiet w NAV_GROUPS (ktore czesciowo maja emoji wpisane na
// sztywno w tekst, niespojnie) -- Sidebar renderuje ikone + tekst oddzielnie,
// wiec potrzebuje wlasnego, czystego zrodla ikon per pozycja.
export const NAV_ITEM_ICONS = {
  dashboard: '🏠', logger: '📻', logbook: '📖', map: '🗺️', stats: '📊', mypropagation: '🧭',
  dxccmap: '🌏', analysis: '📈', klub: '👥', eqsl: '🎨', qsl: '📇', upload: '📤', trash: '🗑️',
  cluster: '🌐', dxneeded: '🎯', watchlist: '⭐', pota: '🏞️', wwff: '🌲',
  pskreporter: '📶', satellites: '🛰️', websdr: '🎧', svxlink: '🔊', weather: '🌦️', propagation: '☀️',
  diplomas: '🏆', news: '📰', contests: '🏁', dxpeditions: '✈️', mostwanted: '💎',
  neighbors: '🏘️', nets: '📋', skeds: '⏰', station: '🎛️', year: '🎉', swl: '👂', antenna: '📐',
  'dxcc-matrix': '🔢', azimuthal: '🔭', bandmap: '📊', keyer: '📣',
  'cw-decoder': '🔤', 'cw-trainer': '🎓', 'path-calc': '📏', 'qso-rate': '⏱️', 'activation-planner': '🏕️',
  aprs: '📍', 'live-roster': '📻', admin: '🛠️',
  beacons: '📡', 'alert-rules': '🔔', chat: '💬', market: '🛒', ranking: '🥇', exam: '🎓',
};

// Nadpisania ikon dla motywow Terminal/Neon -- tylko te dwa maja WLASNY,
// odrebny zestaw (reszta -- dark/light/calm/xp/vista -- celowo BEZ zmian,
// uzywa NAV_ITEM_ICONS powyzej). Brak wpisu dla danej pozycji = fallback na
// domyslna ikone.
export const THEME_NAV_ICONS = {
  terminal: {
    logger: '💾', logbook: '📀', map: '🛰️', stats: '📊', mypropagation: '🧭',
    dxccmap: '🌐', analysis: '📉', klub: '🖧', eqsl: '📤', qsl: '📠', upload: '📤', trash: '🗑️',
    cluster: '📟', dxneeded: '🎯', watchlist: '🔔', pota: '🌲', wwff: '🌳',
    pskreporter: '📡', satellites: '🛰️', websdr: '📻', svxlink: '🎚️', weather: '⛅',
    diplomas: '🏅', news: '🗞️', contests: '🏆', dxpeditions: '🧭', mostwanted: '❗',
    neighbors: '🖧', nets: '📑', skeds: '🗓️', station: '🎚️', year: '🏁', swl: '📡', antenna: '📡', 'cw-decoder': '🔡', 'cw-trainer': '⌨️', admin: '🔧',
  },
  neon: {
    logger: '⚡', logbook: '💠', map: '🌐', stats: '📊', mypropagation: '🧭',
    dxccmap: '🔮', analysis: '📈', klub: '👾', eqsl: '💫', qsl: '✉️', upload: '🚀', trash: '♻️',
    cluster: '🌈', dxneeded: '🎯', watchlist: '🔮', pota: '🌴', wwff: '🍃',
    pskreporter: '✨', satellites: '🛸', websdr: '🎛️', svxlink: '🎙️', weather: '🌩️',
    diplomas: '💎', news: '📡', contests: '🏆', dxpeditions: '🚀', mostwanted: '🌟',
    neighbors: '👥', nets: '📋', skeds: '⏰', station: '🎛️', year: '🎆', swl: '🎧', antenna: '📶', 'cw-decoder': '🔠', 'cw-trainer': '🕹️', admin: '⚙️',
  },
};

export function navIconFor(theme, itemId) {
  return THEME_NAV_ICONS[theme]?.[itemId] || NAV_ITEM_ICONS[itemId] || '▸';
}

// Pomocnik do ikon per-widok (poza nawigacja) -- domyslny emoji zostaje
// identyczny dla 5 oryginalnych motywow (dark/light/calm/xp/vista), tylko
// terminal/neon moga dostac wlasny.
export function themeIcon(theme, defaultIcon, terminalIcon, neonIcon) {
  if (theme === 'terminal' && terminalIcon) return terminalIcon;
  if (theme === 'neon' && neonIcon) return neonIcon;
  return defaultIcon;
}

// Ulozenie menu -- pasek gorny (domyslne, bez zmian dla nikogo kto nie wejdzie
// do ustawien) albo boczny pasek z lewej/prawej. Zapisywane w localStorage,
// tak jak motyw -- to preferencja WYSWIETLANIA (per przegladarka), nie dana
// konta.
export function useNavLayout() {
  const [navLayout, setNavLayoutState] = useState(() => localStorage.getItem('nav_layout') || 'sidebar-left');
  const setNavLayout = (v) => {
    setNavLayoutState(v);
    localStorage.setItem('nav_layout', v);
  };
  return [navLayout, setNavLayout];
}

// Ekran startowy po zalogowaniu -- domyslnie Logger (bez zmian dla nikogo, kto
// nie wejdzie do ustawien), opcjonalnie Pulpit (Dashboard). Jak reszta
// preferencji UI -- localStorage, per przegladarka.
export function useStartView() {
  const [startView, setStartViewState] = useState(() => localStorage.getItem('start_view') || 'logger');
  const setStartView = (v) => {
    setStartViewState(v);
    localStorage.setItem('start_view', v);
  };
  return [startView, setStartView];
}

// Gestosc tabeli Logbooka -- 'normal' (domyslnie) albo 'compact' (wiecej
// wierszy na ekranie, mniejszy padding/font -- przydatne przy duzych logach).
export function useTableDensity() {
  const [density, setDensityState] = useState(() => localStorage.getItem('table_density') || 'normal');
  const setDensity = (v) => {
    setDensityState(v);
    localStorage.setItem('table_density', v);
  };
  return [density, setDensity];
}

// Makra klawiszy funkcyjnych (F1-F6) -- szybkie wstawianie gotowego tekstu do
// pola notatek podczas logowania (np. "TNX QSO 73", "Nowy kraj!"), jak
// klawisze F w N1MM+/kontestowych loggerach (tam wysylaja tekst przez CW/SSB
// keyer -- tu, bez integracji z nadawaniem, po prostu wypelniaja notatki,
// zeby nie tracic czasu na pisanie tego samego w kolko w pileupie/zawodach).
// Zapisywane w localStorage (per przegladarka), jak reszta preferencji UI.
const DEFAULT_NOTE_MACROS = [
  { key: 'F1', text: 'TNX QSO 73!' },
  { key: 'F2', text: tx('Nowy kraj (DXCC)!') },
  { key: 'F3', text: tx('Nowe pasmo/mode z tą stacją') },
  { key: 'F4', text: tx('QSL via biuro') },
  { key: 'F5', text: tx('Prosi o powtórzenie raportu') },
  { key: 'F6', text: tx('Silny sygnał, czysty ton') },
];

export function useNoteMacros() {
  const [macros, setMacrosState] = useState(() => {
    try {
      const saved = JSON.parse(localStorage.getItem('note_macros') || 'null');
      return Array.isArray(saved) && saved.length ? saved : DEFAULT_NOTE_MACROS;
    } catch { return DEFAULT_NOTE_MACROS; }
  });
  const setMacros = (next) => {
    setMacrosState(next);
    localStorage.setItem('note_macros', JSON.stringify(next));
  };
  return [macros, setMacros];
}

// Wspoldzielony hook motywu -- WCZESNIEJ kazdy z 4 miejsc uzywajacych
// przelacznika (TermsPage, ekran logowania, glowna apka, ...) mial WLASNY,
// skopiowany useState+useEffect. Jeden z nich (TermsPage) mial nawet buga --
// zmiana motywu tam nie zapisywala sie do localStorage, wiec cofala sie po
// odswiezeniu. Jeden hook = jedno miejsce do naprawy/rozszerzenia (stad latwo
// bylo dolozyc tu 3 nowe motywy zamiast 4 razy).
export function useTheme() {
  const [theme, setThemeState] = useState(() => localStorage.getItem('theme') || 'dark');
  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
  }, [theme]);
  const setTheme = (t) => {
    setThemeState(t);
    localStorage.setItem('theme', t);
  };
  return [theme, setTheme];
}

export function useIsMobile(breakpoint = 768) {
  const [isMobile, setIsMobile] = useState(
    typeof window !== 'undefined' ? window.innerWidth <= breakpoint : false
  );
  useEffect(() => {
    const mq = window.matchMedia(`(max-width: ${breakpoint}px)`);
    const handler = (e) => setIsMobile(e.matches);
    mq.addEventListener('change', handler);
    return () => mq.removeEventListener('change', handler);
  }, [breakpoint]);
  return isMobile;
}

// Lista zakladek nawigacji -- wspoldzielona przez nav desktopowy i szuflade
// mobilna, zeby nie powtarzac tej samej listy w dwoch miejscach.
// Struktura nawigacji pogrupowana logicznie -- zamiast 13 plaskich przyciskow
// w jednym rzedzie. Kazda grupa staje sie rozwijanym menu na desktopie i
// sekcja z naglowkiem w szufladzie mobilnej.
// Nawigacja tlumaczona przez t() -- przekazywane z komponentu (useI18n).
// Fallback: gdy t nie podano (np. stary kod/test), zwracamy klucze polskie.
